import { MQTT_PREFIX } from "../services/mqtt/mqttconfig";

/**
 * Where to deep-link a spa from the API-key tables.
 *
 * A spa that lives in the v2 DB (`spaV2Id` present) links to the in-app page — the details
 * page for staff, the control page for a customer. A spa that hasn't been migrated links to
 * the legacy portal's spadetails page, keyed by its old GUID — the same v1/v2 split
 * SpasTable makes on `is_moved`.
 */

const isColdTub = (): boolean => {
  const brand = localStorage.getItem("data-brand");
  if (brand) return brand === "coldtub";
  return window.location.hostname.includes("mycoldtub");
};

/** Old dealer-portal spadetails URL for an un-migrated (v1) tub. Mirrors SpasTable. */
export const v1SpaLink = (spaGuid?: string | null): string | null => {
  if (!spaGuid) {
    return null;
  }
  const domain = isColdTub() ? "mycoldtub.com" : "myarcticspa.com";
  const site = MQTT_PREFIX.includes("beta") ? `beta.${domain}/dealers` : `${domain}/dealers`;
  return `https://${site}/spadetails.aspx?SpaGUID=${spaGuid}&ignore_redirect=true`;
};

/**
 * Resolve a spa link: v2 in-app route when the spa is migrated, else the legacy portal link.
 * `isStaff` picks details vs control for v2. Returns null only when neither id nor guid exists.
 */
export const spaLink = (
  isStaff: boolean,
  spaV2Id?: string | null,
  spaGuid?: string | null,
): string | null => {
  if (spaV2Id) {
    return isStaff ? `/spa/${spaV2Id}` : `/spa-control/${spaV2Id}`;
  }
  return v1SpaLink(spaGuid);
};

/** True when the resolved link is an in-app (v2) route rather than an external portal URL. */
export const isInAppLink = (path: string | null): boolean => !!path && path.startsWith("/");
